import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    // First navigate to home if not already there
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleHomeClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center mb-6"> 
              <svg 
                width="32" 
                height="32" 
                viewBox="0 0 100 100" 
                className="text-[#EE7F01]"
              >
                <g transform="translate(0,-952.36216)">
                  <path 
                    className="fill-current"
                    d="m 49.979083,957.36216 -25.142573,13.00244 0.02091,25.9726 25.397236,51.025 24.908919,-51.0579 -0.02099,-25.97231 -25.163495,-12.96983 z m 0.02091,3.96408 21.416994,11.05742 0,22.11483 -21.416994,11.05741 -21.416995,-11.05741 0,-22.11483 21.416995,-11.05742 z"
                  />
                  <path 
                    className="fill-current"
                    d="m 46.216046,981.37189 15.844743,-10.99793 -8.276708,15.13629 -15.844743,10.99793 z"
                  />
                </g>
              </svg>
              <span className="ml-2 text-xl font-bold text-white">
                KI-Navigatoren
              </span>
            </div>
            <p className="text-gray-400 mb-4">
              Ihr Partner für KI-Beratung und Kompetenznachweis
              nach EU AI Act. Rechtssicher, flexibel und effizient.
            </p>
            <a 
              href="https://www.ki-navigatoren.de" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="block text-[#EE7F01] font-bold hover:text-[#EE7F01]/80 transition-colors"
            >
              www.ki-navigatoren.de
            </a>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Navigation</h3>
            <ul className="space-y-4">
              <li>
                <button 
                  onClick={handleHomeClick}
                  className="hover:text-[#EE7F01] transition-colors text-left"
                >
                  Startseite
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')} 
                  className="hover:text-[#EE7F01] transition-colors text-left"
                >
                  Über den Kurs
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('pricing')} 
                  className="hover:text-[#EE7F01] transition-colors text-left"
                >
                  Preise
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Account</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/registrieren" className="hover:text-[#EE7F01] transition-colors">
                  Registrieren
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-[#EE7F01] transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Rechtliches</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/impressum" className="hover:text-[#EE7F01] transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="hover:text-[#EE7F01] transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/agb" className="hover:text-[#EE7F01] transition-colors">
                  AGB
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {currentYear} KI-Navigatoren. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;